
import { Vue } from "vue-class-component";

export default class DialogPaymentLayout extends Vue {}
